import $ from "jquery";
import { goToByScroll } from "../../lib/content/helper";

$("[data-go-to-by-scroll]").on("click tap", function () {
    let to = $(this).attr("data-go-to-by-scroll");
    let offset = $(this).attr("data-go-to-by-scroll-offset");
    let speed = $(this).attr("data-go-to-by-scroll-speed");
    let container = $(this).attr("data-go-to-by-scroll-container");
    goToByScroll(to, offset, speed, container);
});

$("[data-hash-click]").on("click tap", function (e) {
    e.preventDefault();
    let hash = $(this).attr("data-hash-click");
    let offset = $(this).attr("data-hash-click-offset");

    history.pushState(null, null, `#${hash}`);

    $("html").removeClass("s_user-clicked-menu");

    const element = $(`[data-scroll-id="${hash}"]`);
    goToByScroll(element, offset, 300, "body, html");
});

function exemptHashes(hash) {
    let exempted_hashes = ["overlay", "gallery"];
    hash = hash.split("%");

    // console.log(hash[0]);
    // console.log(exempted_hashes.includes(hash[0]));

    return !exempted_hashes.includes(hash[0]);
}

/**
 * Scroll by hash, on page load
 */
if (window.location.hash) {
    let hash = location.hash;
    hash = remove_first_character(hash);
    // console.debug(hash);

    if (exemptHashes(hash)) {
        if ($(`[data-item-slug="${hash}"]`).length > 0) {
            $(`[data-item-slug="${hash}"]`).addClass("s_is-open");
            goToByScroll(`[data-item-slug="${hash}"]`, 60);
        }

        if ($(`[data-scroll-id="${hash}"]`).length > 0) {
            setTimeout(() => {
                goToByScroll(`[data-scroll-id='${hash}']`, 60);
            }, 300);
        }
    }
}

function hashHandler() {
    let hash = location.hash;
    if (!hash) {
        return;
    }
    console.debug(hash);
    hash = remove_first_character(hash);
    if (exemptHashes(hash)) {
        goToByScroll(`[data-scroll-id='${hash}']`, 100);
    }
}

window.addEventListener("hashchange", hashHandler, false);

function remove_first_character(element) {
    return element.slice(1);
}
